/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactPlatform
 */

'use strict';

var Platform = {
  OS: 'winjs'
};

module.exports = Platform;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/Platform/Platform.winjs.js
 **/